export const EntityPrefix = {
    OBJECT: 'bj',
    GOODS_SERVICE: 'gs',
};
const ALL_PREFIXES = Object.values(EntityPrefix);
export const formatEntityNumber = (prefix, internalNumber) => {
    if (internalNumber == null || String(internalNumber).trim() === '')
        return '';
    return `${prefix}-${internalNumber}`;
};
export const stripEntityPrefix = (value) => {
    if (!value)
        return null;
    const trimmed = value.trim();
    for (const prefix of ALL_PREFIXES) {
        if (trimmed.toLowerCase().startsWith(`${prefix}-`)) {
            return trimmed.slice(prefix.length + 1);
        }
    }
    return trimmed;
};
